module.exports = __webpack_public_path__ + "static/media/editIcon.b30b6cdb.svg";